'use client';
var classes = {"weekday":"m-18a3eca"};

export default classes;
//# sourceMappingURL=WeekdaysRow.module.mjs.map
